import { ReactComponent as IconHome } from "./light_tabbar_home.svg";
import { ReactComponent as IconHomeSelected } from "./light_tabbar_home_selected.svg";
import { ReactComponent as IconMarket } from "./light_tabbar_market.svg";
import { ReactComponent as IconMarketSelected } from "./light_tabbar_market_selected.svg";
import { ReactComponent as IconTrade } from "./light_tabbar_trade.svg";
import { ReactComponent as IconTradeSelected  } from "./light_tabbar_trade_selected.svg";
import { ReactComponent as IconAsstes } from "./light_tabbar_assets.svg";
import { ReactComponent as IconAsstesSelected } from "./light_tabbar_assets_selected.svg";

import { ReactComponent as IconNavbarHistory} from "./navbar_history.svg";
import { ReactComponent as IconNavbarFeedback} from "./navbar_feedback.svg";
import { ReactComponent as IconNavbarMessage} from "./navbar_message.svg";

import { ReactComponent as IconAvatar} from "./icon_avatar.svg";
import { ReactComponent as IconRecharge } from "./icon_recharge.svg";
import { ReactComponent as IconWithdraw } from "./icon_withdraw.svg";
import { ReactComponent as IconMarkets } from "./icon_market.svg";
import { ReactComponent as IconFutures } from "./icon_futures.svg";
import { ReactComponent as IconTransfer } from "./icon_transfer.svg";

import { ReactComponent as IconSecurity } from "./icon_security.svg";
import { ReactComponent as IconCurrency } from "./icon_currency.svg";
import { ReactComponent as IconLanguage } from "./icon_language.svg";
import { ReactComponent as IconContact } from "./icon_contact.svg";
import { ReactComponent as IconAbout } from "./icon_about.svg";

import { ReactComponent as IconTrend } from "./icon_trend.svg";
import { ReactComponent as IconFavorites } from "./icon_favorites.svg";
import { ReactComponent as IconFavoritesOK } from "./icon_favorites_ok.svg";
import { ReactComponent as IconTradeMore } from "./trade_more.svg";

import { ReactComponent as IconLogo } from "./logo_45c.svg";
import { ReactComponent as IconMoreR4 } from "./icon_more_r4.svg";

import { ReactComponent as IconLogoR } from "./logo.svg";

import { ReactComponent as IconApple } from "./icon_apple.svg";
import { ReactComponent as IconAndroid } from "./icon_android.svg";

import React from "react";

export const AppleIcon = React.memo(() => {
    return (<IconApple/>)
});

export const AndroidIcon = React.memo(() => {
    return (<IconAndroid/>)
});

export const LogoIconR = React.memo(() => {
    return (<IconLogoR/>)
});

export const TradeMoreIcon = React.memo(() => {
    return (<IconTradeMore/>)
});

export const FavoritesIcon = React.memo(() => {
    return (<IconFavorites/>)
});

export const FavoritesOKIcon = React.memo(() => {
    return (<IconFavoritesOK/>)
});

export const TrendIcon = React.memo(() => {
    return (<IconTrend/>)
});

export const MoreR4Icon = React.memo(() => {
    return (<IconMoreR4/>)
});

export const LogoIcon = React.memo(() => {
    return (<IconLogo/>)
});

export const AvatarIcon = React.memo(() => {
    return (<IconAvatar/>)
});

export const NavbarFeedbackIcon = React.memo(() => {
    return (<IconNavbarFeedback/>)
});

export const NavbarHistoryIcon = React.memo(() => {
    return (<IconNavbarHistory/>)
});

export const NavbarMessageIcon = React.memo(() => {
    return (<IconNavbarMessage/>)
});

export const HomepageIcon = React.memo((props) => {
    if (props.active) {
        return (<IconHomeSelected/>)
    }
    return (<IconHome/>)
});

export const MarketIcon = React.memo((props) => {
    if (props.active) {
        return (<IconMarketSelected/>)
    }
    return (<IconMarket/>)
});

export const TradeIcon = React.memo((props) => {
    if (props.active) {
        return (<IconTradeSelected/>)
    }
    return (<IconTrade/>)
});

export const AssetsIcon = React.memo((props) => {
    if (props.active) {
        return (<IconAsstesSelected/>)
    }
    return (<IconAsstes/>)
});

export const RechargeIcon = React.memo(() => {
    return (<IconRecharge/>)
});

export const WithdrawIcon = React.memo(() => {
    return (<IconWithdraw/>)
});

export const MarketsIcon = React.memo(() => {
    return (<IconMarkets/>)
});

export const FuturesIcon = React.memo(() => {
    return (<IconFutures/>)
});

export const TransferIcon = React.memo(() => {
    return (<IconTransfer/>)
});

export const SecurityIcon = React.memo(() => {
    return (<IconSecurity/>)
});

export const CurrencyIcon = React.memo(() => {
    return (<IconCurrency/>)
});

export const LanguageIcon = React.memo(() => {
    return (<IconLanguage/>)
});

export const ContactIcon = React.memo(() => {
    return (<IconContact/>)
});

export const AboutIcon = React.memo(() => {
    return (<IconAbout/>)
});